<template>
  <div class="navbar-bookmarks flex items-center">
    <div class="bookmark-container">
      <vx-tooltip text="Diseño Menu" position="bottom" delay=".3s">
      <vs-dropdown vs-trigger-click>
        <feather-icon :icon="checkCurrentLayoutIcon" class="cursor-pointer p-2"/>
        <vs-dropdown-menu>
          <vs-dropdown-item  @click="changeCurrentLayout()" :disabled="this.layoutType === 'vertical'">
            <div class="flex py-1">
              <feather-icon icon="ColumnsIcon" svgClasses="h-4 w-4"/>
              <span class="text-sm mr-1 ml-1">Diseño vertical</span>
            </div>
          </vs-dropdown-item>
          <vs-dropdown-item  @click="changeCurrentLayout()" :disabled="this.layoutType === 'horizontal'">
            <div class="flex py-1">
              <feather-icon icon="CreditCardIcon" svgClasses="h-4 w-4"/>
              <span class="text-sm mr-1 ml-1">Diseño horizontal</span>
            </div>
            <!-- <feather-icon :icon="checkCurrentLayoutIcon" class="cursor-pointer p-2" @click="changeCurrentLayout()"/> -->
          </vs-dropdown-item>
        </vs-dropdown-menu>
      </vs-dropdown>
      </vx-tooltip>
    </div>
  </div>
</template>

<script>
import VxAutoSuggest from '@/components/vx-auto-suggest/VxAutoSuggest.vue'

export default {
  props: {
    navbarColor: {
      type: String,
      default: '#fff'
    }
  },
  components: {
    VxAutoSuggest
  },
  data () {
    return {
      showBookmarkPagesDropdown : false
    }
  },
  watch: {
    '$route' () {
      if (this.showBookmarkPagesDropdown) this.showBookmarkPagesDropdown = false
    }
  },
  computed: {
    //Para cambiar el modo del tema
    currentLayout () {
      return this.$store.state.mainLayoutType
    },
    checkCurrentLayoutText () {
      return this.currentLayout === 'vertical' ? 'Diseño Vertical' : 'Diseño Horizontal'
    },
    checkCurrentLayoutIcon () {
      return this.currentLayout === 'vertical' ? 'LayoutIcon' : 'LayoutIcon'
    },
    themeMode: {
      get ()    { return this.$store.state.theme },
      set (val) { this.$store.dispatch('updateTheme', val) }
    },
    layoutType: {
      get ()    { return this.$store.state.mainLayoutType },
      set (val) { this.$store.dispatch('updateCurrentLayout', val) }
    },
    navbarSearchAndPinList () {
      return {pages: this.$store.state.navbarSearchAndPinList['pages']}
    },
    starredPages () {
      return this.$store.state.starredPages
    },
    starredPagesLimited: {
      get () {
        return this.starredPages.slice(0, 10)
      },
      set (list) {
        this.$store.dispatch('arrangeStarredPagesLimited', list)
      }
    },
    starredPagesMore: {
      get () {
        return this.starredPages.slice(10)
      },
      set (list) {
        this.$store.dispatch('arrangeStarredPagesMore', list)
      }
    },
    textColor () {
      return {'text-white': this.$store.state.mainLayoutType === 'vertical' && this.navbarColor !== (this.$store.state.theme === 'dark' ? '#2B2B2B' : '#fff') }
    }
  },
  methods: {
    changeCurrentLayout () {
      this.currentLayout === 'vertical' ? this.layoutType = 'horizontal' : this.layoutType = 'vertical'
    },
    selected (obj) {
      this.$store.commit('TOGGLE_CONTENT_OVERLAY', false)
      this.showBookmarkPagesDropdown = false
      this.$router.push(obj.pages.url).catch(() => {})
    },
    actionClicked (item) {
      this.$store.dispatch('updateStarredPage', { url: item.url, val: !item.is_bookmarked })
      // this.$refs.bookmarkAutoSuggest.filterData()
    },
    outside () {
      this.showBookmarkPagesDropdown = false
    },
    hnd_search_query_update (query) {
      // Show overlay if any character is entered
      this.$store.commit('TOGGLE_CONTENT_OVERLAY', !!query)
    }
  },
  directives: {
    'click-outside': {
      bind (el, binding) {
        const bubble = binding.modifiers.bubble
        const handler = (e) => {
          /* eslint-disable no-mixed-operators */
          if (bubble || !el.contains(e.target) && el !== e.target) {
          /* eslint-enable no-mixed-operators */
            binding.value(e)
          }
        }
        el.__vueClickOutside__ = handler
        document.addEventListener('click', handler)
      },

      unbind (el) {
        document.removeEventListener('click', el.__vueClickOutside__)
        el.__vueClickOutside__ = null

      }
    }
  }
}

</script>
